var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product__fetch-error"},[_vm._v("\n  "+_vm._s(_vm.$t(
      'Sorry, an error occurred while searching for the product you requested.'
    ))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }